import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16.997 20.41l-3.408-3.407 1.4-1.407 3.41 3.408zM5.59 19L7 20.41l6-6V8h3.5L12 3.5 7.5 8H11v5.59z"
}), 'CallMergeTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CallMergeTwoTone.js
// module id = 2603
// module chunks = 2